<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    class="create-archiving-dialog common-dialog"
  >
    <div class="archiving-illustrate">
      <div>数据归档说明：</div>
      <div>1）数据归档为连续归档；</div>
      <div>2）最新的11块高无法归档；</div>
    </div>
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="create-archiving-form"
    >
      <el-form-item label="数据库IP" prop="ip">
        <el-input v-model="dataForm.ip" placeholder="请输入数据库IP"></el-input>
      </el-form-item>
      <el-form-item label="数据库端口" prop="port">
        <el-input v-model="dataForm.port" placeholder="请输入数据库端口"></el-input>
      </el-form-item>
      <el-form-item label="数据库用户名" prop="user">
        <el-input v-model="dataForm.user" placeholder="请输入数据库用户名"></el-input>
      </el-form-item>
      <el-form-item label="数据库密码" prop="pwd">
        <el-input v-model="dataForm.pwd" placeholder="请输入数据库密码" show-password></el-input>
      </el-form-item>
      <el-form-item label="归档方式" prop="archivingType">
        <el-radio-group v-model="dataForm.archivingType" @change="onTypeChanged">
          <el-radio :label="1">基于时间</el-radio>
          <el-radio :label="2">基于区块高度</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="dataForm.archivingType == 1" label="选择日期" prop="time">
        <el-date-picker
          v-model="dataForm.time"
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item v-else label="区块高度" prop="height">
        <el-input-number
          v-model="dataForm.height"
          controls-position="right"
          :min="0"
          :max="totalBlockHeight - 11"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <div>
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          @click="submitForm()"
          >立即创建</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateArchiving',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  props: {
    totalBlockHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      title: '新增归档数据',
      dialogVisible: false,
      dataForm: {
        chainid: '',
        ip: '',
        port: '',
        blocks: '',
        user: '',
        pwd: '',
        time: '',
        height: null,
        archivingType: 1
      },
      rules: {
        ip: [
          { required: true, message: '请输入数据库IP', trigger: ['blur', 'change'] },
          {
            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
            message: '请输入有效的IP地址',
            trigger: ['blur', 'change']
          }
        ],
        port: [
          { required: true, message: '请输入数据库端口', trigger: ['blur', 'change'] },
          { pattern: /^[1-9]\d{0,4}$/, message: '请输入有效的端口 ', trigger: ['blur', 'change'] }
        ],
        user: [{ required: true, message: '请输入数据库用户名', trigger: ['blur', 'change'] }],
        pwd: [{ required: true, message: '请输入数据库密码', trigger: ['blur', 'change'] }],
        time: [{ required: true, message: '请选择归档时间', trigger: ['blur', 'change'] }]
      },
      fullscreenLoading: false,
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen() {
      let sInfoStr = localStorage.getItem('cbaas_blockchain_archiving_server')
      let sInfo = {}
      if (sInfoStr) {
        try {
          sInfo = JSON.parse(sInfoStr)
        } catch (e) {
          console.log(e)
        }
      }
      this.dataForm = {
        ip: sInfo.ip,
        port: sInfo.port,
        blocks: '',
        user: sInfo.user,
        pwd: sInfo.pwd,
        time: '',
        height: null,
        archivingType: 1
      }
      this.dialogVisible = true
    },
    onTypeChanged(val) {
      this.dataForm.time = ''
      this.dataForm.height = null
      this.$refs['dataForm'].clearValidate()
    },
    submitForm() {
      let self = this
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          console.log('submit!!')
          let apiName = 'dumpByHeight'
          if (self.dataForm.archivingType == 1) {
            apiName = 'dumpByTime'
          }
          let params = {
            height: self.dataForm.height,
            time: self.dataForm.time,
            blocks: 10000,
            chainid: self.$route.query.chainId,
            secret_key: self.$route.query.chainId,
            db_info: {
              ip: self.dataForm.ip,
              port: self.dataForm.port,
              user: self.dataForm.user,
              pwd: self.dataForm.pwd
            }
          }
          localStorage.setItem('cbaas_blockchain_archiving_server', JSON.stringify(params.db_info))
          self.fullscreenLoading = true
          self.$apis.chain[apiName](params)
            .then(data => {
              self.fullscreenLoading = false
              if (!data.errors) {
                self.dialogVisible = false
                self.$message.success('归档成功')
                self.$emit('createSuccess')
              }
            })
            .catch(err => {
              self.fullscreenLoading = false
              console.log(err)
            })
        } else {
          console.log('error submit!!')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'create-archiving-dialog',
  (
    --create-archiving-dialog-illustrate-border-color: #4b5471
  ),
  (
    --create-archiving-dialog-illustrate-border-color: #ebebeb
  )
);

.create-archiving-dialog.common-dialog {
  @include adaptation(
    (
      --create-archiving-dialog-body-padding: 40px 40px 0px 40px,
      --create-archiving-dialog-illustrate-padding: 15px 10px 10px 40px,
      --create-archiving-dialog-illustrate-height: 100px,
      --create-archiving-dialog-illustrate-border-width: 1px,
      --create-archiving-dialog-illustrate-border-radius: 6px,
      --create-archiving-dialog-illustrate-font-size: 14px,
      --create-archiving-dialog-illustrate-line-height: 22px,
      --create-archiving-dialog-form-margin-top: 20px,
      --create-archiving-dialog-form-margin-right: 30px,
    )
  );

  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  /deep/ .el-dialog__body {
    padding: var(--create-archiving-dialog-body-padding);

    .archiving-illustrate {
      width: 100%;
      padding: var(--create-archiving-dialog-illustrate-padding);
      height: var(--create-archiving-dialog-illustrate-height);
      margin: 0 auto;
      border: var(--create-archiving-dialog-illustrate-border-width) dashed
        var(--create-archiving-dialog-illustrate-border-color);
      border-radius: var(--create-archiving-dialog-illustrate-border-radius);
      font-size: var(--create-archiving-dialog-illustrate-font-size);
      line-height: var(--create-archiving-dialog-illustrate-line-height);
    }

    .create-archiving-form {
      margin-top: var(--create-archiving-dialog-form-margin-top);
      margin-right: var(--create-archiving-dialog-form-margin-right);
    }
  }
}
</style>
